
<template>
  <section class="wrapper">
    <chc-tab-control ref="tabControl">
      <chc-tab-pane label="Vehicle Reports">
        <data-reports></data-reports>
      </chc-tab-pane>
      <chc-tab-pane label="Charity Reports">
        <charity-reports></charity-reports>
      </chc-tab-pane>
      <chc-tab-pane label="IRS Reports">
        <irs-reports></irs-reports>
      </chc-tab-pane>
    </chc-tab-control>
  </section>
</template>

<script>
import DataReports from './DataReports'
import CharityReports from './CharityReports'
import IrsReports from './IrsReports'
import store from '@/store'

export default {
  name: 'Reports',
  beforeRouteEnter (to, from, next) {
    Promise.all([
      store.dispatch('syncConstants'),
      store.dispatch('syncSummary'),
    ]).catch(() => {
      next(vm => vm.$router.push({name: ''}))
    }).then(() => {
      next()
    })
  },
  props: {
  },
  data () {
    return {

    }
  },
  methods: {
  },
  components: {
    DataReports,
    CharityReports,
    IrsReports
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Reports/Reports.vue